import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, getContext } from 'recompose'
import { injectIntl } from 'react-intl'
import { selectHomeUpdateLoanBalanceRequested } from 'src/store/selectors/home'
import {
  selectLoanBalanceDetails,
  selectPrincipalDiff,
  selectHasSubmittedUPB
} from 'src/store/selectors/home/loans'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool.isRequired
}

const InfoContainer = compose(
  getContext(contextTypes),
  connect(state => ({
    loanDetails: selectLoanBalanceDetails(state) || [],
    balanceDiff: selectPrincipalDiff(state),
    hasSavedUPB: selectHasSubmittedUPB(state),
    upbRequested: selectHomeUpdateLoanBalanceRequested(state)
  })),
  injectIntl
)

export default InfoContainer
